import React from 'react'
import PropTypes from 'prop-types'
import Draggable from 'react-draggable'
import isEmpty from 'lodash/isEmpty'
import Tree, { TreeNode } from 'rc-tree'
import { ButtonToolbar, Button } from 'react-bootstrap'
import { rest } from '../../lib'
import { Times } from 'styled-icons/fa-solid/Times'
import { Check } from 'styled-icons/fa-solid/Check'
import 'rc-tree/assets/index.css'

class ChannelSelector extends React.Component {
  constructor(...args) {
    super(...args)
    this.saved = []
    this.nodes = []
    this.changed = false

    this.state = {
      position: this.props.defaultPosition,
      checkedKeys: [],
      tree: [],
    }
  }

  componentDidMount() {
    this._isMounted = true
    this.fetchTree()
  }
  componentWillUnmount = () => this._isMounted = true

  fetchTree = () => {
    rest.driverConfig('').then(resp => {
      console.log(resp)
     if (this._isMounted) this.loadTree(resp.configs)
    })
  }


  loadTree = arr => {
    if (!arr) return
    const { defaultNodes, log } = this.props

    const treeNodes = arr.map( (device, i) => {
      const id = device.id + (device.description ? ' (' + device.description + ')' : '')
      const node = { name: id, key: i, leaf: !device.hasOwnProperty('channels') || isEmpty(device.channels) }
      if (node.leaf) {
        node.children = []
      } else {
        let j = 0
        node.children = device.channels.reduce( (r, o) => {
          if (log && o.loggingInterval <= 0) return r

          const keyValue = [i,j++].join('-')
          if (defaultNodes.indexOf(o.id) !== -1) this.nodes.push({key: keyValue, name: o.id})
          r.push({ name: o.id, key: keyValue, leaf: true })
          return r
        }, [])
      }
      return node
    })

    this.saved = this.nodes.slice()
    this.setState({ checkedKeys: this.getKeys(), tree: treeNodes })
  }

  getKeys = () => this.nodes.map(o => o.key)
  getNames = () => this.nodes.map(o => o.name)

  onStopDrag = e => this.setState({ position: {x: e.clientX, y:e.clientY } })
  onCheck = (keys, e) => {
    this.changed = true
    this.nodes = e.checkedNodes.reduce((result, o) => {
      if (o.props.isLeaf) result.push({ key: o.key, name: o.props.title })
      return result
    }, [])

    this.setState({ checkedKeys: this.getKeys() })
  }

  confirm = () => {
    if (this.changed) {
      this.props.onUpdate(this.getNames())
      this.saved = this.nodes.slice()
    } else {
      this.props.onUpdate(null)
    }
    this.changed = false
  }

  cancel = () => {
    if (this.changed) {
      this.nodes = this.saved.slice()
      this.setState({ checkedKeys: this.getKeys() })
    }
    this.props.onUpdate(null)
    this.changed = false
  }

  renderNode = (data) => {
    if (!data) return null
    return data.map(node => {
      if (node.children) {
        return (
          <TreeNode title={node.name} key={node.key} isLeaf={node.leaf}>
            {this.renderNode(node.children)}
          </TreeNode>
        )
      }
      return <TreeNode title={node.name} key={node.key} isLeaf={node.leaf}/>
    })
  }

  render() {
    if (!this.props.show) return null
    const { position, checkedKeys, tree } = this.state

    return (
      <Draggable axis='both' handle='.panel-heading' defaultPosition={position} onStop={this.onStopDrag}>
        <div className='panel panel-info panel-dark' style={{width:400}}>
          <div className='panel-heading'>
            <span className='panel-title'>Channel Selector</span>
          </div>
          <div className='panel-body tree-pane'>
            <Tree onCheck={this.onCheck} checkedKeys={checkedKeys} showIcon={false} checkable>{this.renderNode(tree)}</Tree>
          </div>
          <div className='panel-footer'>
            <ButtonToolbar>
              <Button bsStyle='danger' bsSize='small' className='btn-outline' onClick={this.cancel}><Times size={14}/> Cancel</Button>
              <Button bsStyle='primary' bsSize='small' className='btn-outline pull-right' onClick={this.confirm}><Check size={14}/> Done</Button>
            </ButtonToolbar>
          </div>
        </div>
      </Draggable>
    )
  }
}

ChannelSelector.defaultProps = {
  defaultPosition: {x:100, y:100},
  defaultNodes: [],
  onUpdate: () => {},
  log: false,
  show: false,
}

ChannelSelector.propTypes = {
  defaultPosition: PropTypes.object,
  defaultNodes: PropTypes.array,
  onUpdate: PropTypes.func,
  log: PropTypes.bool,
  show: PropTypes.bool
}

export default ChannelSelector



// WEBPACK FOOTER //
// ./src/components/widgets/ChannelSelector.js